import { Check, MessageCircle, Sparkles, Video } from "lucide-react";
import { MockAvatar } from "@/src/common/components/app-mock/avatar";
import { getPerson, MOCK_MATCHES, VIEWER } from "@/src/common/components/app-mock/mock-community";
import { MockButton, MockCard, MockChip } from "@/src/common/components/app-mock/primitives";
import { useCommunityVariant } from "@/src/common/components/product-demo/community-variant-context";

interface WebMatchScreenProps {
	maxMatches?: number;
}

export function WebMatchScreen({ maxMatches }: WebMatchScreenProps) {
	const { palette } = useCommunityVariant();
	const matches = maxMatches ? MOCK_MATCHES.slice(0, maxMatches) : MOCK_MATCHES;
	return (
		<div className="space-y-3" data-mock="match">
			<div className="flex items-center justify-between">
				<div>
					<h2 className="flex items-center gap-1.5 text-sm font-semibold text-neutral-900">
						<Sparkles className="size-3.5" style={{ color: palette.accent }} />
						Match AI
					</h2>
					<p className="text-[10px] text-neutral-500">
						People {VIEWER.shortName} should meet this week, based on goals, fields and activity.
					</p>
				</div>
			</div>
			<div className="space-y-2">
				{matches.map((match) => {
					const person = getPerson(match.personId);
					return (
						<MockCard key={match.id} dataMock="match-card">
							<div className="flex items-start gap-2.5">
								<MockAvatar person={person} size={34} presence={person.presence === "online" ? "online" : undefined} />
								<div className="min-w-0 flex-1">
									<div className="flex flex-wrap items-center gap-1.5">
										<span className="truncate text-[11px] font-semibold text-neutral-900">{person.name}</span>
										<MockChip color="accent" size="xs">
											{match.score}% match
										</MockChip>
									</div>
									<p className="truncate text-[10px] text-neutral-500">
										{person.title} · {person.company}
									</p>
									<ul className="mt-1.5 space-y-0.5">
										{match.reasons.map((reason) => (
											<li key={reason} className="flex items-center gap-1 text-[10px] text-neutral-700">
												<Check className="size-3 shrink-0" style={{ color: palette.accent }} />
												{reason}
											</li>
										))}
									</ul>
								</div>
								<div className="flex shrink-0 flex-col gap-1">
									<MockButton size="xs" icon={Video}>
										Schedule
									</MockButton>
									<MockButton size="xs" variant="outline" icon={MessageCircle}>
										Message
									</MockButton>
								</div>
							</div>
						</MockCard>
					);
				})}
			</div>
		</div>
	);
}
